import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'clients',
    component: () => import('@/Pages/Clients'),
  },
  {
    path: '/clients/add',
    name: 'client-add',
    component: () => import('@/Pages/ClientAdd'),
  },
  {
    path: '/clients/:id',
    props: true,
    name: 'client',
    component: () => import('@/Pages/Client'),
  },
  {
    path: '/clients/:id/edit',
    props: true,
    name: 'client-edit',
    component: () => import('@/Pages/ClientEdit'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/Pages/About'),
  },
]

const router = new VueRouter({
  scrollBehavior() {
    return window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
